<template>
  <div class="userLog-main-content">
    <div class="search">

      <el-form class="searchForm" :model="searchForm">
        <el-form-item>
          <el-input size="small" v-model="searchForm.keyword" placeholder="输入邮箱、手机、国家、公司.."></el-input>
        </el-form-item>


        <el-form-item>
          <el-select clearable size="small" v-model="searchForm.userLevel" placeholder="用户等级">
            <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select clearable size="small" v-model="searchForm.expireFlag" placeholder="过期状态">
            <el-option v-for="item in expireList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">新增用户</el-button>
        </el-form-item>
      </el-form>

    </div>
    <div class="table">
      <!-- table start -->
      <el-table stripe size="medium" :data="list" highlight-current-row v-loading="loading" border
        element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column prop="email" label="用户账号" align="center" min-width="120"></el-table-column>

        <el-table-column prop="mobile" label="用户手机" align="center" min-width="80"></el-table-column>

        <el-table-column label="用户等级" align="center" min-width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.userLevel === 1" type="info">普通用户</el-tag>
            <el-tag v-if="scope.row.userLevel === 2" type="success">高级用户</el-tag>
            <el-tag v-if="scope.row.userLevel === 3" type="danger">VIP用户</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="注册时间" align="center" min-width="80">
          <template slot-scope="scope">
            <div>{{ scope.row.createDate | timestampToDay }}</div>
          </template>
        </el-table-column>

        <el-table-column label="过期时间" align="center" min-width="80">
          <template slot-scope="scope">
            <div>{{ scope.row.expireDate | timestampToDay }}</div>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="50">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.expireFlag === 1" type="primary">有效</el-tag>
            <el-tag v-if="scope.row.expireFlag === 2" type="danger">过期</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="country" label="国家" min-width="70"></el-table-column>
        <el-table-column prop="company" label="公司信息" min-width="90"></el-table-column>

        <el-table-column align="center" label="操作" min-width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="primary" plain @click="handleLog(scope.row.id)">操作记录</el-button>
            <el-button size="mini" type="danger" plain @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- table end -->

      <!-- page start -->
      <Pagination :params="pageParams" @pageList="pageList"></Pagination>
      <!-- page end -->

      <!-- edit start -->
      <el-dialog :title="editTitle" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
        <el-form label-width="140px" :model="formData" :rules="rules" ref="formData">

          <el-form-item style="margin-bottom:6px;" label="用户账号" prop="email">
            <el-input size="small" style="width:80%" v-model="formData.email" class="form-input"></el-input>
          </el-form-item>

          <el-form-item style="margin-bottom:6px;" label="用户密码" prop="password">
            <el-input size="small" style="width:80%" v-model="formData.password" class="form-input"></el-input>
          </el-form-item>

          <el-form-item style="margin-bottom:6px;" label="国家" prop="country">
            <el-input size="small" style="width:80%" v-model="formData.country" class="form-input"></el-input>
          </el-form-item>

          <el-form-item style="margin-bottom:6px;" label="用户等级" prop="userLevel">
            <el-select v-model="formData.userLevel" placeholder="选择用户等级">
              <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item style="margin-bottom:6px;" label="过期时间" prop="expireDate">
            <el-col :span="16">
              <el-date-picker type="date" placeholder="选择日期(不填默认7天过期)" v-model="formData.expireDate"
                style="width: 100%;"></el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item style="margin-bottom:6px;" label="手机" prop="mobile">
            <el-input size="small" style="width:80%" v-model="formData.mobile" class="form-input"></el-input>
          </el-form-item>

          <el-form-item style="margin-bottom:6px;" label="公司" prop="company">
            <el-input size="small" style="width:80%" v-model="formData.company" class="form-input"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:6px;" label="brands">
            <el-input size="small" style="width:80%" v-model="formData.brands" class="form-input"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:6px;" label="whatapp">
            <el-input size="small" style="width:80%" v-model="formData.whatapp" class="form-input"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:6px;" label="wechat">
            <el-input size="small" style="width:80%" v-model="formData.wechat" class="form-input"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="submitForm('formData')">提交保存</el-button>
            <el-button size="small" @click="closeDialog">取消</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        </div>
      </el-dialog>
      <!-- edit end -->

      <!-- userLog-timeline start -->
      <el-dialog title="用户操作记录" lock-scroll modal :visible.sync="editFormVisibleUserLog" width="40%"
        @click="closeDialog">
        <div style="height:500px;overflow:auto;">
          <UserLogsTimeline :list="userLogList"></UserLogsTimeline>
        </div>
      </el-dialog>
      <!-- userLog-timeline end -->


    </div>
  </div>
</template>

<script>
import { user_page, user_add, user_update, user_del, userLog_list_by_user, user_refresh_token } from "../api/api";
import './../assets/css/userLog.css';
import Pagination from "../components/Pagination";
import UserLogsTimeline from "../components/UserLogsTimeline";

export default {
  data() {
    return {
      timer: null, // 定时器

      // 页面控制元素
      loading: false, //是否显示加载
      editTitle: '', //编辑页面标题
      editType: 1, // 新增/修改
      editFormVisible: false, // 编辑页面显隐
      editFormVisibleUserLog: false, // 用户操作记录对话框

      // 搜索表单
      searchForm: {
        keyword: '',
        userType: null,
        expireFlag: 1
      },

      // 分页表单
      pageParams: {
        currentPage: 1,
        pageSize: 25,
        total: 0
      },

      // 编辑表单
      formData: {
        id: "",
        email: "",
        mobile: "",
        company: "",
        password: "",
        country: "",
        brands: "",
        whatapp: "",
        wechat: "",
        userLevel: 1,
        userType: 1,
        expireDate: null,
        expireFlag: null
      },
      rules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        country: [{ required: true, message: "请输入国家", trigger: "blur" }]
      },

      // 列表
      list: [],

      // 用户操作列表
      userLogList: [],

      // 其他固定字典项
      levelList: [
        { value: 1, label: '普通' },
        { value: 2, label: '高级' },
        { value: 3, label: 'VIP' }
      ],
      expireList: [
        { value: 1, label: '有效' },
        { value: 2, label: '到期' }
      ]
    };
  },
  // 注册组件
  components: { Pagination, UserLogsTimeline },

  created() {
    // 定时器 start
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer();
    // 定时器 end

    this.page(this.pageParams.currentPage, this.pageParams.pageSize);
  },
  destroyed: function () {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
  },

  methods: {
    // 定时器
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.refreshToken();
        }, 10 * 60 * 1000)
      }
    },
    async refreshToken() {
      let param = { "page": "userinfo", "token": window.localStorage.getItem("user") }
      const data = await user_refresh_token(param);
      window.localStorage.setItem("user", data.data);
    },

    // ----------------------search start---------------------
    search() {
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },
    // 分页插件事件
    pageList(currentPage, pageSize) {
      this.page(currentPage, pageSize);
    },
    // 分页查询
    async page(currentPage, pageSize) {
      // 查询
      const param = {};
      param.currentPage = currentPage;
      param.pageSize = pageSize;

      param.userType = 1;
      param.keyword = this.searchForm.keyword;
      param.expireFlag = this.searchForm.expireFlag;
      param.userLevel = this.searchForm.userLevel;

      const data = await user_page(param);

      this.pageParams.total = data.data.total;
      this.pageParams.pageSize = data.data.pageSize;
      this.pageParams.currentPage = data.data.currentPage;
      this.list = data.data.list;

      if (this.pageParams.total > 0 && this.pageParams.total == (this.pageParams.currentPage - 1) * this.pageParams.pageSize) {
        this.getData(this.pageParams.currentPage - 1, this.pageParams.pageSize, this.pageParams.city);
      } else {
        this.list = data.data.list;
      }
    },
    // ----------------------search end---------------------

    // ----------------------add start---------------------
    handleEdit: function (row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.editTitle = "修改用户信息";
        this.editType = 2;

        this.formData.id = row.id;
        this.formData.email = row.email;
        this.formData.mobile = row.mobile;
        this.formData.company = row.company;
        this.formData.country = row.country;
        this.formData.brands = row.brands;
        this.formData.whatapp = row.whatapp;
        this.formData.wechat = row.wechat;
        this.formData.userLevel = row.userLevel;
        this.formData.password = row.password;
        this.formData.expireDate = row.expireDate;
        this.formData.userType = 1;
      } else {
        this.editTitle = "新增用户信息";
        this.editType = 1;

        this.formData.id = "";
        this.formData.email = "";
        this.formData.mobile = "";
        this.formData.company = "";
        this.formData.country = "";
        this.formData.brands = "";
        this.formData.whatapp = "";
        this.formData.wechat = "";
        this.formData.userLevel = 1;
        this.formData.userType = 1;
        this.formData.password = "";
        this.formData.expireDate = null;
      }
    },

    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.editType == 1) {
            this.add(this.formData);
          }
          else if (this.editType == 2) {
            this.update(this.formData);
          }
          this.editFormVisible = false;
          this.loading = false;
        } else {
          return false;
        }
      });
    },

    //新增 修改
    async add() {
      await user_add(this.formData);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearFormData();
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },
    async update() {
      await user_update(this.formData);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.clearFormData();
      this.page(this.pageParams.currentPage, this.pageParams.pageSize);
    },

    clearFormData() {
      this.formData.id = "";
      this.formData.email = "";
      this.formData.mobile = "";
      this.formData.company = "";
      this.formData.country = "";
      this.formData.brands = "";
      this.formData.whatapp = "";
      this.formData.wechat = "";
      this.formData.password = "";
      this.formData.expireDate = null;
    },
    closeDialog() {
      this.clearFormData();
      this.editFormVisible = false;
    },
    closeDialogUserLog() {
      this.clearFormData();
      this.editFormVisibleUserLog = false;
    },


    // ----------------------add end-----------------------


    // ----------------------delete start-------------------
    // 删除文章
    handleDelete(index, id) {
      this.delConfirm(index, id);
    },
    //删除确认对话框
    delConfirm(index, id) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          user_del(id).then(res => {
            if (res.code === 1) {
              // 刷新页面请求
              this.list.splice(index, 1);
              this.page(
                this.pageParams.currentPage,
                this.pageParams.pageSize
              );
            } else {
              this.$message({
                type: "success",
                message: "删除失败!"
              });
            }
          });

          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // ----------------------delete end---------------------

    // ----------------------userlog start---------------------
    handleLog: function (userId) {
      this.queryUserLogList(userId);
    },
    async queryUserLogList(userId) {
      // 查询
      const param = {};
      param.userId = userId;
      param.sort = "desc";

      // const data = await userLog_list_by_user(param);
      let logList = this.userLog_list(param);

      logList.then(it => {
        this.userLogList = it;
        setTimeout(() => {
          this.editFormVisibleUserLog = true;
        }, 1);
      })
    },
    async userLog_list(param) {
      const data = await userLog_list_by_user(param);
      return data.data;
    },
    // ----------------------userlog end---------------------
  }
};
</script>





// WEBPACK FOOTER //
// src/views/UserInfo.vue